import SiteFooter from './SiteFooter';
export default SiteFooter;

//# sourceMappingURL=index.js.map